import React from 'react';
import * as MyCells from '../../../../utils/Cells';
import ActionMenu from '../../../common/action/ActionMenu';
import { ListCell } from '../../../common/cells/ListCell';
import DateRangeColumnFilter, { DateRangeColumnFilterFn } from '../../../common/filters/DateRangeColumnFilter';
import TextColumnFilter from '../../../common/filters/TextColumnFilter';
import StatusCell from '../../../common/cells/StatusCell';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../../common/filters/StateMultiSelectColumnFilter';
import { MultiSelectFilterFn } from '../../../common/filters/Filters';
import MultiSelectColumnFilter from '../../../common/filters/MultiSelectColumnFilter';
import { NavLink } from "react-router-dom";
import VisibilityIcon from '@material-ui/icons/Visibility';

export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'stateLabel',
            id: 'stateLabel',
            show: true,
            className: 'status',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Munkaszám',
            accessor: 'publicId',
            id: 'publicId',
            show: true,
            className: 'idColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Helyszín',
            accessor: 'location',
            id: 'location',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Rövid név',
            accessor: 'shortName',
            id: 'shortName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Vevők',
            accessor: 'customers',
            filter: 'fuzzyText',
            id: 'customers',
            show: true,
            Filter: TextColumnFilter,
            Cell: props => <ListCell cell={props} delimiter=', ' attribute='name' />,
        },
        {
            Header: 'Fizetés (napok)',
            accessor: 'paymentCommitmentInDays',
            id: 'paymentCommitmentInDays',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Számlázási típus',
            accessor: 'billingTypeLabel',
            id: 'billingTypeLabel',
            show: true,
            className: 'idColumn center',
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            Header: 'Projekt kezdete',
            accessor: 'startDate',
            id: 'startDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Projekt vége',
            accessor: 'endDate',
            id: 'endDate',
            show: true,
            className: 'dateColumn',
            Filter: DateRangeColumnFilter,
            filter: DateRangeColumnFilterFn,
            Cell: props => <MyCells.DateCell value={props.value} />,
        },
        {
            Header: 'Megjegyzés',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: () => null, // No header
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Cell: value =>
                <div className='action-cell'>
                    <NavLink to={`/projectdetail/${value?.row?.original?.privateId}`} className="detail-button">
                        <VisibilityIcon fontSize="small" color="primary" />
                    </NavLink >
                    <ActionMenu row={value.row.original} tabletype={'project'} refresh={refresh} />
                </div>
        },
    ]
}